<form [formGroup]="form" (submit)="onSubmit()" class="overflow">
  <div class="credit-memo-form_wrapper">
    <h3>{{ mode }} Credit Memo</h3>
    <div class="form-group">
      <label class="lum-label">Label</label>
      <input type="text" class="lum-input" matInput formControlName="label" />
      <mat-error *ngIf="labelControl && labelControl.invalid">{{
        labelControl | validateField
      }}</mat-error>
    </div>
    <div class="form-group">
      <lum-ui-field-label label="Credit Memo (Amount)"></lum-ui-field-label>
      <input
        type="number"
        min="1"
        class="lum-input"
        matInput
        formControlName="creditMemo"
        lumDecimalLimit
      />
      <mat-error *ngIf="creditMemoControl && creditMemoControl.invalid">{{
        creditMemoControl | validateField
      }}</mat-error>
    </div>
    <div class="form-group">
      <label class="lum-label">Remarks</label>
      <textarea
        name="remarks"
        class="lum-textarea"
        matInput
        formControlName="remarks"
        rows="3"
      ></textarea>
    </div>

    <div
      formArrayName="invoiceEntries"
      *ngIf="invoiceEntriesControl.controls.length > 0"
    >
      <label for=""> <b>Invoice Entries:</b></label>
      <div
        class="row"
        *ngFor="let invoiceEntry of invoiceEntriesControl.controls; let i = index"
        [formGroupName]="i"
      >
        <div class="col-md-12">
          <hr />
          <div class="flex gap-4">
            <div class="flex grow flex-column gap-4">
              <div class="flex gap-2">
                <div class="grow">
                  <div class="form-group" append-to="body">
                    <label class="lum-label">Invoice Number</label>
                    <input
                      placeholder="Search Invoice Number..."
                      [value]="invoiceEntry.value?.invoiceId"
                      type="text"
                      matInput
                      class="lum-input"
                      [ngClass]="{
                        'text-red': !invoiceEntry.value?.isSelected,
                      }"
                      [matAutocomplete]="auto"
                      (input)="onInvoiceInputChange($event, i)"
                      formControlName="invoiceId"
                    />
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      [displayWith]="displayFn"
                      (optionSelected)="onSelectedInvoice($event, i)"
                    >
                      <mat-option
                        disabled
                        class="loading"
                        *ngIf="invoiceLoading$ | async; else invoiceList"
                      >
                        <mat-spinner diameter="25"></mat-spinner>
                      </mat-option>
                      <ng-template #invoiceList>
                        <mat-option
                          *ngFor="
                            let invoice of filteredInvoices;
                            trackBy: trackById
                          "
                          [value]="invoice.id"
                        >
                          Invoice# <strong>{{ invoice?.id }} </strong>
                        </mat-option>
                      </ng-template>
                    </mat-autocomplete>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex grow flex-column gap-4">
              <div class="flex gap-2">
                <div class="grow">
                  <div class="form-group">
                    <label class="lum-label">Amount</label>
                    <input
                      type="number"
                      class="lum-input"
                      matInput
                      formControlName="amount"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="flex grow flex-column gap-4 pt-2">
              <div class="flex gap-2">
                <div class="grow">
                  <div class="form-group">
                    <label class="lum-label">&nbsp;</label>
                    <lum-ui-icon
                      class="cursor-pointer"
                      icon="delete-bin-2"
                      [width]="20"
                      [height]="20"
                      color="#f24f63"
                      (click)="onRemoveInvoiceEntry(i)"
                    ></lum-ui-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-content-end mb-4">
      <button
        class="lum-button lum-button--secondary"
        type="button"
        (click)="addInvoiceEntry()"
        [disabled]="form.invalid"
      >
        <!-- <i class="fas fa-plus"></i> Add Invoice -->

        <lum-ui-icon
          class="mr-2"
          icon="add-1"
          [width]="16"
          [height]="16"
          color="#5563d6"
        ></lum-ui-icon
        >Add Invoice
      </button>
    </div>
    <div class="flex justify-end">
      <button
        type="button"
        class="lum-button lum-button--tertiary mr-5"
        mat-dialog-close
      >
        Cancel
      </button>
      <button
        class="lum-button lum-button--primary"
        type="submit"
        [disabled]="form.invalid || loading"
      >
        Submit
      </button>
    </div>
  </div>
</form>
